<template>
  <div class="insight">
    <div class="headerbox">
      <div class="searchbox">
        <el-input
          style="height: 45px"
          clearable
          placeholder="搜索联盟客名称"
          v-model="searchValue"
          @change="searchData"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="filiter">
        <img
          src="@/assets/img/mobile/shaixuan.png"
          alt=""
          @click="filiterShow = true"
        />
      </div>
    </div>

    <div class="infinite-list-wrapper">
      <div
        class="scrollbox"
        :infinite-scroll-distance="10"
        v-infinite-scroll="scrollData"
        infinite-scroll-disabled="disabled"
        infinite-scroll-immediate="false"
      >
        <el-card
          shadow="never"
          class="box-card"
          v-for="item in affList"
          :key="item.allianceCode"
        >
          <div class="affitem">
            <el-row>
              <el-col :span="5">
                <div class="headsrc" @click="goDetail(item.allianceCode)">
                  <el-avatar :size="60" :src="item.headSrc"></el-avatar>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="name" @click="goDetail(item.allianceCode)">
                  {{ item.name }}
                </div>
                <div class="subdesc" @click="goDetail(item.allianceCode)">
                  {{ item.countryName }}
                </div>
              </el-col>
              <el-col :span="7">
                <div class="goods">
                  <img
                    v-if="item.isConcern == 1"
                    src="@/assets/img/home/love.png"
                    alt=""
                    @click="cancelgroup(item)"
                  />
                  <img
                    v-else
                    src="@/assets/img/home/love2.png"
                    alt=""
                    @click="joingroup(item)"
                  />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
        <el-divider v-if="loading">加载中...</el-divider>
        <el-divider v-if="noMore && totalpages > 0">没有更多了</el-divider>
        <div class="nodata" v-if="totalpages === 0">
          <img src="@/assets/img/nodata.png" alt="" />
          <div>暂无数据</div>
        </div>
      </div>
    </div>

    <el-drawer :visible.sync="filiterShow" :with-header="false" size="65%">
      <div class="myfiliter">
        <div class="title">品牌</div>
        <!-- <el-select
          v-model="params.brand"
          filterable
          placeholder="请选择"
          style="height: 40px; margin-bottom: 8px"
        >
          <el-option
            style="width: 240px"
            v-for="item in brandList"
            :key="item.brandCode"
            :label="item.brandName"
            :value="item.brandCode"
          >
          </el-option>
        </el-select> -->
        <LoadMoreSelect
          style="height: 40px; margin-bottom: 8px"
          v-model="params.brand"
          :initialPage="initialPage"
          :pageSize="pageSize"
          :fetchOptions="fetchStockLocationData"
          keyField="brandCode"
          labelField="brandName"
          valueField="brandCode"
        ></LoadMoreSelect>

        <div class="title">国家/地区</div>
        <el-select
          v-model="params.country"
          filterable
          placeholder="请选择"
          style="height: 40px; margin-bottom: 8px"
        >
          <el-option
            v-for="item in countryList"
            :key="item.value"
            :label="item.value"
            :value="item.code"
          >
          </el-option>
        </el-select>
        <div class="title">类型</div>
        <el-select
          v-model="params.propTypes"
          filterable
          placeholder="请选择"
          style="height: 40px; margin-bottom: 8px"
        >
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.value"
            :value="item.code"
          >
          </el-option>
        </el-select>
        <div class="title">平台</div>
        <el-select
          v-model="params.affiliateNetworks"
          filterable
          placeholder="请选择"
          style="height: 40px; margin-bottom: 8px"
        >
          <el-option
            v-for="item in plamList"
            :key="item.value"
            :label="item.lavaluebel"
            :value="item.code"
          >
          </el-option>
        </el-select>
        <div class="title">排序</div>
        <el-select
          v-model="params.orderRule"
          filterable
          placeholder="Choose"
          style="height: 40px; margin-bottom: 8px"
        >
          <el-option label="推荐" value="default"> </el-option>
          <el-option label="粉丝数" value="fans"> </el-option>
          <el-option label="发现时间" value="newJoin"> </el-option>
        </el-select>
        <div class="title">有无邮箱</div>
        <el-select
          v-model="params.hasEmail"
          filterable
          placeholder="Choose"
          style="height: 40px; margin-bottom: 8px"
        >
          <el-option label="全部" value=""> </el-option>
          <el-option label="有" value="1"> </el-option>
        </el-select>

        <div class="footer">
          <el-row :gutter="8">
            <el-col :span="12">
              <div class="reset">
                <el-button
                  type="primary"
                  style="width: 100%"
                  @click="resetFiliter"
                  >重置</el-button
                >
              </div>
            </el-col>
            <el-col :span="12">
              <div class="submit">
                <el-button
                  type="primary"
                  style="width: 100%"
                  @click="searchData"
                  >确定</el-button
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {
  INDUSTRYS,
  BRANDSBYINDUSTRY,
  BRANDS,
  BRAND,
  CHECKBRAND,
  COUNTRYBRAND,
  INDUSTRYY,
  QUERYSELECTLIST,
  QUERYUSERGROUP,
  QUERY,
  JOINGROUP,
  CHECKALLINDUSTRYBRAND,
  QUERYHASGROUP,
  QUERYCHAT
} from '@/api/cutting'
import { REMOVEGROUPONEDETAIL } from '@/api/foll'
import { mapActions, mapGetters } from 'vuex'
import LoadMoreSelect from '@/components/LoadMoreSelect.vue'
export default {
  components: {
    LoadMoreSelect
  },
  data() {
    return {
      searchValue: '',
      params: {
        currentPage: 1,
        size: 10,
        brand: '',
        country: '',
        propTypes: '',
        affiliateNetworks: '',
        name: '',
        orderRule: 'default',
        hasEmail: ''
      },
      totalpages: null,
      loading: false,
      affList: [],
      filiterShow: false,
      brandList: [],
      countryList: [],
      typeList: [],
      plamList: [],
      initialPage: 1,
      pageSize: 50
    }
  },
  computed: {
    noMore() {
      return this.totalpages == this.params.currentPage
    },
    disabled() {
      return this.loading || this.totalpages == this.params.currentPage
    },
    headerTitle() {
      let result = ''
      this.brandList.forEach((item) => {
        if (item.brandCode == this.params.brand) {
          result = item.brandName
        }
      })
      return result
    }
  },
  created() {
    this.permitsList()
  },
  mounted() {},
  methods: {
    ...mapActions(['changeRouterTitle']),
    //获取下拉数据
    permitsList() {
      BRANDS({ size: this.pageSize, currentPage: 1 }).then((res) => {
        this.brandList = res.data.body
        this.params.brand = res.data.body[0].brandCode
        this.getData()
      })
      QUERYSELECTLIST().then((res) => {
        this.countryList = res.data.body.countryList
        this.typeList = res.data.body.typeList
        this.plamList = res.data.body.platformList
      })
    },
    //重置条件
    resetFiliter() {
      this.params = {
        currentPage: 1,
        size: 10,
        brand: this.brandList[0].brandCode,
        country: '',
        propTypes: '',
        affiliateNetworks: '',
        name: ''
      }
      this.searchData()
      this.filiterShow = false
    },
    getData() {
      this.loading = true
      BRAND(this.params)
        .then((res) => {
          this.changeRouterTitle(this.headerTitle)
          this.affList = []
          this.totalpages = res.data.body.pages
          let arr = res.data.body.records
          this.affList = arr
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    //搜索联盟客
    searchData() {
      this.params.name = this.searchValue
      this.params.currentPage = 1
      this.getData()
      this.filiterShow = false
    },
    scrollData() {
      this.params.currentPage++
      this.loading = true
      BRAND(this.params)
        .then((res) => {
          this.changeRouterTitle(this.headerTitle)
          this.totalpages = res.data.body.pages
          let arr = res.data.body.records
          this.affList = this.affList.concat(arr)
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    // 关注
    joingroup(e) {
      let userGroups = [
        {
          groupCode: 'concern001',
          allianceCode: e.allianceCode
        }
      ]
      JOINGROUP({ userGroups }).then((res) => {
        if (res.data.code == 'success') {
          this.$message({
            message: '已关注',
            type: 'success'
          })
          e.isConcern = '1'
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 取消关注
    cancelgroup(e) {
      REMOVEGROUPONEDETAIL({
        groupCode: 'concern001',
        allianceCode: e.allianceCode
      }).then((res) => {
        if (res.data.code == 'success') {
          this.$message({
            message: '已取消关注',
            type: 'success'
          })
          e.isConcern = '0'
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    goDetail(id) {
      this.$router.push({ path: '/detail-m', query: { code: id } })
    },
    async fetchStockLocationData({ page, pageSize }) {
      const res = await BRANDS({ size: pageSize, currentPage: page })
      if (res.data.body.length !== 0) {
        this.brandList = res.data.body
        this.params.brand = res.data.body[0].brandCode
        this.getData()
        return res.data
      }
    }
  }
}
</script>
<style lang="less" scoped>
.insight {
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  padding: 53px 8px 8px 8px;
  background-color: #fff;

  /deep/.el-card__body {
    padding: 8px !important;
  }

  .headerbox {
    display: flex;
    position: fixed;
    top: 58px;
    width: calc(100% - 16px);
    background-color: #fff;
    z-index: 10;

    .searchbox {
      flex: auto;
    }

    .filiter {
      padding: 5px;

      img {
        width: 35px;
        height: 35px;
      }
    }
  }

  .infinite-list-wrapper {
    margin-top: 8px;
    height: 100%;

    .scrollbox {
      height: 100%;
      overflow: auto;
    }

    .box-card {
      margin-bottom: 8px;

      .affitem {
        height: 60px;

        .headsrc {
          height: 60px;
          line-height: 60px;
        }

        .name {
          height: 30px;
          line-height: 30px;
          font-weight: 600;
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .subdesc {
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .goods {
          display: flex;
          height: 60px;
          flex-direction: row;
          flex-wrap: nowrap;
          text-align: center;
          justify-content: flex-end;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }

    .nodata {
      margin-top: 45%;
      text-align: center;

      div {
        margin-top: 8px;
        color: #bfbfbf;
      }
    }
  }
}

.myfiliter {
  height: 100%;
  width: 100%;
  padding: 8px;
  position: relative;

  .title {
    font-weight: 600;
    margin-bottom: 8px;
  }

  .footer {
    padding-top: 8px;
    width: calc(100% - 16px);
    position: absolute;
    bottom: 8px;

    .reset {
      width: 100%;
    }

    .submit {
      width: 100%;
    }
  }
}
</style>
